<div
  class="sgt-toast sgt-toast--{{ type }}"
  [class.sgt-toast--expandido]="isExpandido"
  [attr.role]="type === 'error' ? 'alert' : 'status'"
  [attr.aria-live]="type === 'error' ? 'assertive' : 'polite'"
  (mouseenter)="pausar()"
  (mouseleave)="iniciarTimer()"
  (focusin)="pausar()"
  (focusout)="iniciarTimer()">
  <i class="sgt-toast__icon fas" [ngClass]="icone"></i>
  <div class="sgt-toast__content">
    <p class="sgt-toast__title" *ngIf="title">{{ title }}</p>
    <p class="sgt-toast__message">{{ message }}</p>
    <button *ngIf="action" type="button" class="sgt-toast__action" (click)="executarAcao()">
      {{ action.label }}
    </button>
  </div>
  <button *ngIf="temBotaoFechar" type="button" class="sgt-toast__close" title="Fechar" aria-label="Fechar" (click)="close()">
    <i class="fas fa-times"></i>
  </button>
</div>
